/* The projects, shared by the hero (device stage) and the projects section. */
export interface Project {
    id: string;
    name: string;
    services: string;
    link: string;
    webPackage: 'Silver' | 'Gold' | 'Platinum';
    reviewText?: string;
    reviewStars?: number;
}

/* Every project has a page of its own at /projecten/<id>, and its pictures in /assets/images/projects/<id>/. */
export const projectPath = (id: string) => `/projecten/${id}`;
export const projectImage = (id: string, name: string) => `/assets/images/projects/${id}/${name}.webp`;

export const projectsList: Project[] = [
    {
        id: 'nerv-models',
        name: 'Nerv Models',
        services: '3D print service, design studio',
        link: 'https://nervmodels.be',
        webPackage: 'Silver',
    },
    {
        id: 'roos-heylen',
        name: 'Roos Heylen',
        services: 'Content & UGC creator',
        link: 'https://roosheylen.be',
        webPackage: 'Silver',
        reviewText: 'Alexander heeft mij uitstekend geholpen met mijn nieuwe website. Snelle, professionele service en vlotte communicatie!',
        reviewStars: 5,
    },
    {
        id: 'studiebooster',
        name: 'StudieBooster',
        services: 'Studiebegeleiding & Bijles',
        link: 'https://studiebooster.be/',
        webPackage: 'Silver',
    },
    {
        id: 'bosmans-studentenkamers',
        name: 'Bosmans Studentenkamers',
        services: 'Verhuur studentenkamers',
        link: 'https://bosmans-studentenkamers.be',
        webPackage: 'Gold',
        reviewText: 'Alexander heeft voor onze koten een zeer gebruiksvriendelijke website gemaakt en ook de communicatie verliep zeer vlot',
        reviewStars: 5,
    },
    {
        id: 'acom-detailing',
        name: 'Acom Detailing',
        services: 'Car detailing, lakcorrectie & coating',
        link: 'https://acomdetailing.be/',
        webPackage: 'Gold',
        reviewText: 'Alexander heeft mij voorzien van een nieuwe moderne website. Vlotte communicatie en snelle oplevering.',
        reviewStars: 5,
    },
    {
        id: 'tuinen-tuur-geerits',
        name: 'Tuinen Tuur Geerits',
        services: 'Tuinaanleg, onderhoud',
        link: 'https://tuinentuurgeerits.be/',
        webPackage: 'Silver',
        reviewText: 'Ik ben ontzettend tevreden over het werk dat is geleverd bij het maken van mijn website.',
        reviewStars: 5,
    },
];
